import type {
    ApiResponse,
    AutocompleteDestination,
    BasicHotelsResponse,
    FetchHeaders,
    Filters,
    HotelPageState,
    SearchResultsState,
} from '@/interfaces';
import { filtersToHotelApiQueryParams, filtersToHotelsApiQueryParams } from './kayakFilterConversion';
import { fetchFromApi } from '@/utils/fetch/apiFetch';
import { getThemeAutocomplete } from '@/server/themes/autocomplete';

let autocompleteController: AbortController;

export const getHotels = async (filters: Filters, headers?: FetchHeaders): Promise<ApiResponse<SearchResultsState>> =>
    fetchFromApi(`/kayak/hotels?${filtersToHotelsApiQueryParams(filters)}`, { headers });

export const getHotelsBasic = async (
    filters: Filters,
    pageSize: number,
    headers?: FetchHeaders,
): Promise<ApiResponse<BasicHotelsResponse>> =>
    fetchFromApi(`/kayak/hotels/basic?${filtersToHotelsApiQueryParams(filters, pageSize)}`, { headers });

export const getHotel = async (filters: Filters, headers?: FetchHeaders): Promise<ApiResponse<HotelPageState>> =>
    fetchFromApi(`/kayak/hotel?${filtersToHotelApiQueryParams(filters)}`, { headers });

export const getAutocompleteResults = async (searchTerm: string): Promise<ApiResponse<AutocompleteDestination[]>> => {
    if (autocompleteController) {
        autocompleteController.abort();
    }
    setAutocompleteController();
    return fetchFromApi<AutocompleteDestination[]>(`/autocomplete?query=${encodeURIComponent(searchTerm)}`, {
        signal: autocompleteController.signal,
    }).then((res) => {
        if (res.status >= 200 && res.status < 300) {
            const themes = getThemeAutocomplete(encodeURIComponent(searchTerm));
            return { ...res, data: themes.concat(res.data) };
        }
        return res;
    });
};

export const setAutocompleteController = (controller: AbortController = new AbortController()): void => {
    autocompleteController = controller;
};
